import { NgModule } from '@angular/core';

import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';

// Modules Material utilises

// Autres modules externes utilises 

// Modules communs utilises
import { CheckboxListModule } from '../../../shared/checkbox-list/checkbox-list.module';
import { FilterableSelectModule } from '../../../shared/filterable-select/filterable-select.module';
import { TasksModule } from '../../../technical-modules/tasks/tasks.module';

// Modules metier utilises
import { UserModule } from '../../humain/user/user.module';

// Composants metiers
import { AntenneCheckboxListComponent } from './components/antenne-checkbox-list.component';
import { AntenneFilterableSelectorComponent } from './components/antenne-filterable-selector.component';
import { AntenneSelectorComponent } from './components/antenne-selector.component';
import { ChargeConduiteAntenneSelectorComponent } from './components/cc-antenne-selector.component';

// Services metier
import { AntenneService } from './services/antenne.service';

@NgModule({
	imports: [
		BrowserModule,
		FormsModule,

		CheckboxListModule,
		FilterableSelectModule,
		TasksModule,

		UserModule,
	],
	providers: [
		AntenneService,
	],
	declarations: [
		AntenneSelectorComponent,
		AntenneCheckboxListComponent,
		AntenneFilterableSelectorComponent,
		ChargeConduiteAntenneSelectorComponent
	],
	exports: [
		AntenneSelectorComponent,
		AntenneCheckboxListComponent,
		AntenneFilterableSelectorComponent,
		ChargeConduiteAntenneSelectorComponent
	]
})
export class AntenneModule {
	constructor() { }
}